var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasInternet)?_c('v-progress-circular',{staticClass:"ma-5",attrs:{"indeterminate":"","color":"primary","size":"100"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }